module.exports = __webpack_public_path__ + "img/pizza.3d06662d.jpeg";